import { OrganizationTraits } from '@neptune/shared/core-organizations-domain';

export function getServiceAccountsLimit(traits: OrganizationTraits): number | undefined {
  return traits.serviceAccounts?.serviceAccountsLimit;
}

export function hasServiceAccountsSupport(traits: OrganizationTraits): boolean {
  return !!getServiceAccountsLimit(traits);
}
